import React, { useState } from 'react';

const EnterAmount = ({ onCancel, onSubmit, config }) => {
  const [amount, setAmount] = useState('');
  
  const addDigit = (digit) => {
    if (amount.length < 8) {
      setAmount(prev => prev + digit);
    }
  };

  const clearAmount = () => setAmount('');
  
  const formatAmount = (amt) => {
    if (!amt) return '0.00';
    // Digits entered represent whole dollars, cents are always .00
    const dollars = parseInt(amt, 10);
    return dollars.toFixed(2);
  };

  // Calculate OK button height (double the regular button height)
  const getOkButtonHeight = () => {
    const heights = {
      'h-4': 'h-8',
      'h-6': 'h-12', 
      'h-8': 'h-16',
      'h-10': 'h-20',
      'h-12': 'h-24',
      'h-14': 'h-28',
      'h-16': 'h-32'
    };
    return heights[config.ui.keypadButtonHeight] || 'h-32';
  };

  return (
    <div className={`bg-white text-gray-800 h-full flex flex-col p-3 ${config.ui.maxWidth} mx-auto`}>
      {/* Amount Display */}
      <div className="bg-blue-600 text-white rounded-xl p-4 mb-4">
        <div className="text-sm font-medium">Total Amount</div>
        <div className="text-2xl font-bold">${formatAmount(amount)}</div>
      </div>
      
      {/* Enter Amount Section */}
      <div className="mb-4">
        <div className="text-lg font-semibold mb-2">Enter Amount</div>
        <div className="text-sm text-gray-600 mb-4">
          Use the keypad to enter the amount in dollars
        </div>
      </div>
      
      {/* Keypad - buttons with configurable spacing */}
      <div className={`grid grid-cols-4 ${config.ui.keypadGap} p-4`}>
        {/* Row 1 */}
        <button 
          onClick={() => addDigit('1')}
          className={`bg-white border border-gray-200 rounded-2xl ${config.ui.keypadButtonHeight} w-16 text-2xl font-medium hover:bg-gray-50 transition-colors shadow-sm`}
        >
          1
        </button>
        <button 
          onClick={() => addDigit('2')}
          className={`bg-white border border-gray-200 rounded-2xl ${config.ui.keypadButtonHeight} w-16 text-2xl font-medium hover:bg-gray-50 transition-colors shadow-sm`}
        >
          2
        </button>
        <button 
          onClick={() => addDigit('3')}
          className={`bg-white border border-gray-200 rounded-2xl ${config.ui.keypadButtonHeight} w-16 text-2xl font-medium hover:bg-gray-50 transition-colors shadow-sm`}
        >
          3
        </button>
        <button 
          onClick={() => setAmount(prev => prev.slice(0, -1))}
          className={`bg-white border border-gray-200 rounded-2xl ${config.ui.keypadButtonHeight} w-16 text-xl font-medium hover:bg-gray-50 transition-colors flex items-center justify-center shadow-sm`}
        >
          ⌫
        </button>
        
        {/* Row 2 */}
        <button 
          onClick={() => addDigit('4')}
          className={`bg-white border border-gray-200 rounded-2xl ${config.ui.keypadButtonHeight} w-16 text-2xl font-medium hover:bg-gray-50 transition-colors shadow-sm`}
        >
          4
        </button>
        <button 
          onClick={() => addDigit('5')}
          className={`bg-white border border-gray-200 rounded-2xl ${config.ui.keypadButtonHeight} w-16 text-2xl font-medium hover:bg-gray-50 transition-colors shadow-sm`}
        >
          5
        </button>
        <button 
          onClick={() => addDigit('6')}
          className={`bg-white border border-gray-200 rounded-2xl ${config.ui.keypadButtonHeight} w-16 text-2xl font-medium hover:bg-gray-50 transition-colors shadow-sm`}
        >
          6
        </button>
        <button 
          onClick={clearAmount}
          className={`bg-white border border-gray-200 rounded-2xl ${config.ui.keypadButtonHeight} w-16 text-lg font-medium hover:bg-gray-50 transition-colors shadow-sm`}
        >
          Clear
        </button>
        
        {/* Row 3 */}
        <button 
          onClick={() => addDigit('7')}
          className={`bg-white border border-gray-200 rounded-2xl ${config.ui.keypadButtonHeight} w-16 text-2xl font-medium hover:bg-gray-50 transition-colors shadow-sm`}
        >
          7
        </button>
        <button 
          onClick={() => addDigit('8')}
          className={`bg-white border border-gray-200 rounded-2xl ${config.ui.keypadButtonHeight} w-16 text-2xl font-medium hover:bg-gray-50 transition-colors shadow-sm`}
        >
          8
        </button>
        <button 
          onClick={() => addDigit('9')}
          className={`bg-white border border-gray-200 rounded-2xl ${config.ui.keypadButtonHeight} w-16 text-2xl font-medium hover:bg-gray-50 transition-colors shadow-sm`}
        >
          9
        </button>
        <button 
          onClick={() => onSubmit(formatAmount(amount))}
          disabled={!amount}
          className={`bg-blue-600 text-white rounded-2xl ${getOkButtonHeight()} w-16 text-xl font-bold hover:bg-blue-700 disabled:bg-gray-400 transition-colors row-span-2 shadow-sm`}
        >
          OK
        </button>
        
        {/* Row 4 */}
        <div></div> {/* Empty space */}
        <button 
          onClick={() => addDigit('0')}
          className={`bg-white border border-gray-200 rounded-2xl ${config.ui.keypadButtonHeight} w-16 text-2xl font-medium hover:bg-gray-50 transition-colors shadow-sm`}
        >
          0
        </button>
        <div></div> {/* Empty space */}
        <div></div> {/* Empty space - OK button spans here */}
      </div>
    </div>
  );
};

export default EnterAmount;